// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./Cards.css";

// const Cards = ({ filters }) => {
//   const [cardData, setCardData] = useState({
//     BR_DI: "",
//     BR_DFL: "",
//     BR_YC: "",
//     BR_NEW1: "",
//     BR_NEW2: "",
//     Open_DI: "",
//     Open_DFL: "",
//     Open_YC: "",
//     DS_DI: "",
//     DS_DFL: "",
//     DS_YC: ""
//   });

//   useEffect(() => {
//     const hasFilters = Object.values(filters).some(value => value !== "" && value !== null);

//     if (hasFilters) {
//       const fetchData = async () => {
//         try {
//           const response = await axios.get("http://localhost:3006/api/getGraphData", {
//             params: filters
//           });
      
//           const data = response.data;
      
//           const sumArray = (arr) =>
//             Array.isArray(arr) ? arr.reduce((sum, val) => sum + parseInt(val || 0, 10), 0) : 0;
      
//           const BR_DI = sumArray(data.BR_DI) + sumArray(data.BR_MSME);
//           const BR_DFL = sumArray(data.BR_DFL);
//           const BR_YC = sumArray(data.BR_YC);
      
//           const Open_DI = sumArray(data.Open_DI) + sumArray(data.Open_MSME);
//           const Open_DFL = sumArray(data.Open_DFL);
//           const Open_YC = sumArray(data.Open_YC);
      
//           const DS_DI = sumArray(data.DS_DI) + sumArray(data.DS_MSME);
//           const DS_DFL = sumArray(data.DS_DFL);
//           const DS_YC = sumArray(data.DS_YC);
      
//           setCardData({
//             BR_DI: BR_DI.toString(),
//             BR_DFL: BR_DFL.toString(),
//             BR_YC: BR_YC.toString(),
//             BR_NEW1: data.BR_NEW1 || "0",
//             BR_NEW2: data.BR_NEW2 || "0",
      
//             Open_DI: Open_DI.toString(),
//             Open_DFL: Open_DFL.toString(),
//             Open_YC: Open_YC.toString(),
      
//             DS_DI: DS_DI.toString(),
//             DS_DFL: DS_DFL.toString(),
//             DS_YC: DS_YC.toString()
//           });
      
//         } catch (error) {
//           console.error("Error fetching card data:", error);
//         }
//       };
      

//       fetchData();
//     } else {
//       setCardData({
//         BR_DI: "",
//         BR_DFL: "",
//         BR_YC: "",
//         BR_NEW1: "",
//         BR_NEW2: "",
//         Open_DI: "",
//         Open_DFL: "",
//         Open_YC: "",
//         DS_DI: "",
//         DS_DFL: "",
//         DS_YC: ""
//       });
//     }
//   }, [filters]);

//   return (
//     <div className="cards-container-v2">
//       <div className="cards-main">

//         {/* Open Section */}
//         <div className="cards-column">
//           <div className="card-v2 card-type-di">
//             <h3>Total Application in Open_DI</h3>
//             <p>{cardData.Open_DI}</p>
//           </div>
//           <div className="card-v2 card-type-dfl">
//             <h3>Total Application in Open_DFL</h3>
//             <p>{cardData.Open_DFL}</p>
//           </div>
//           <div className="card-v2 card-type-yc">
//             <h3>Total Application in Open_YC</h3>
//             <p>{cardData.Open_YC}</p>
//           </div>
//         </div>

//         {/* DS Section */}
//         <div className="cards-column">
//           <div className="card-v2 card-type-di">
//             <h3>Total Application in DS_DI</h3>
//             <p>{cardData.DS_DI}</p>
//           </div>
//           <div className="card-v2 card-type-dfl">
//             <h3>Total Application in DS_DFL</h3>
//             <p>{cardData.DS_DFL}</p>
//           </div>
//           <div className="card-v2 card-type-yc">
//             <h3>Total Application in DS_YC</h3>
//             <p>{cardData.DS_YC}</p>
//           </div>
//         </div>

//         {/* BR Section */}
//         <div className="cards-column">
//           <div className="card-v2 card-type-di">
//             <h3>
//               Total Application in BR_DI
//               <span className="info-icon" title="Total Applications = DI + MSME applications">i</span>
//             </h3>
//             <p>{cardData.BR_DI}</p>
//           </div>
//           <div className="card-v2 card-type-dfl">
//             <h3>Total Application in BR_DFL</h3>
//             <p>{cardData.BR_DFL}</p>
//           </div>
//           <div className="card-v2 card-type-yc">
//             <h3>Total Application in BR_YC</h3>
//             <p>{cardData.BR_YC}</p>
//           </div>
//         </div>
//       </div>

//       {filters.managerName?.trim() !== "" && (
//         <div className="cards-extra">
//           <div className="card-v2 card-v2-10">
//             <h3>Work Done in Total Projects</h3>
//             <p>{cardData.BR_NEW1}</p>
//           </div>
//           <div className="card-v2 card-v2-11">
//             <h3>Work Done in Total Organizations</h3>
//             <p>{cardData.BR_NEW2}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Cards;
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Cards.css";

const Cards = ({ filters }) => {
  const [loading, setLoading] = useState(false);

  const initialState = {
    BR_DI: "",
    BR_DFL: "",
    BR_YC: "",
    BR_NEW1: "",
    BR_NEW2: "",
    Open_DI: "",
    Open_DFL: "",
    Open_YC: "",
    DS_DI: "",
    DS_DFL: "",
    DS_YC: "",
    Total_Open: "",
    Total_DS: "",
    Total_BR: ""
  };

  const [cardData, setCardData] = useState(initialState);

  useEffect(() => {
    const hasFilters = Object.values(filters || {}).some(
      (value) => value !== "" && value !== null
    );

    if (!hasFilters) {
      setCardData(initialState);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true); // 🔄 Start loading

        const response = await axios.get(
          "https://api-usersreport-insights.haqdarshak.com/api/getGraphData",
          { params: filters }
        );

        const data = response.data;

        const sumArray = (arr) =>
          Array.isArray(arr)
            ? arr.reduce((sum, val) => sum + parseInt(val || 0, 10), 0)
            : 0;

        const BR_DI = sumArray(data.BR_DI) + sumArray(data.BR_MSME);
        const BR_DFL = sumArray(data.BR_DFL);
        const BR_YC = sumArray(data.BR_YC);

        const Open_DI = sumArray(data.Open_DI) + sumArray(data.Open_MSME);
        const Open_DFL = sumArray(data.Open_DFL);
        const Open_YC = sumArray(data.Open_YC);

        const DS_DI = sumArray(data.DS_DI) + sumArray(data.DS_MSME);
        const DS_DFL = sumArray(data.DS_DFL);
        const DS_YC = sumArray(data.DS_YC);

        const Total_Open = Open_DI + Open_DFL + Open_YC;
        const Total_DS = DS_DI + DS_DFL + DS_YC;
        const Total_BR = BR_DI + BR_DFL + BR_YC;

        setCardData({
          BR_DI: BR_DI.toString(),
          BR_DFL: BR_DFL.toString(),
          BR_YC: BR_YC.toString(),
          BR_NEW1: data.BR_NEW1 || "0",
          BR_NEW2: data.BR_NEW2 || "0",

          Open_DI: Open_DI.toString(),
          Open_DFL: Open_DFL.toString(),
          Open_YC: Open_YC.toString(),

          DS_DI: DS_DI.toString(),
          DS_DFL: DS_DFL.toString(),
          DS_YC: DS_YC.toString(),

          Total_Open: Total_Open.toString(),
          Total_DS: Total_DS.toString(),
          Total_BR: Total_BR.toString()
        });
      } catch (error) {
        console.error("Error fetching card data:", error);
      } finally {
        setLoading(false); // ✅ Stop loading
      }
    };

    fetchData();
  }, [filters]);

  const renderValue = (value) => {
    return loading ? (
      <span className="card-spinner"></span>
    ) : (
      value
    );
  };

  return (
    <div className="cards-container-v2">
      <div className="cards-main">

        {/* Open Section */}
        <div className="cards-column">
          <div className="card-v2 card-type-di">
            <h3>Total Application in Open_DI</h3>
            <p>{renderValue(cardData.Open_DI)}</p>
          </div>
          <div className="card-v2 card-type-dfl">
            <h3>Total Application in Open_DFL</h3>
            <p>{renderValue(cardData.Open_DFL)}</p>
          </div>
          <div className="card-v2 card-type-yc">
            <h3>Total Application in Open_YC</h3>
            <p>{renderValue(cardData.Open_YC)}</p>
          </div>
          <div className="card-v2 card-type-total">
            <h3>Total Applications in Open</h3>
            <p>{renderValue(cardData.Total_Open)}</p>
          </div>
        </div>

        {/* DS Section */}
        <div className="cards-column">
          <div className="card-v2 card-type-di">
            <h3>Total Application in DS_DI</h3>
            <p>{renderValue(cardData.DS_DI)}</p>
          </div>
          <div className="card-v2 card-type-dfl">
            <h3>Total Application in DS_DFL</h3>
            <p>{renderValue(cardData.DS_DFL)}</p>
          </div>
          <div className="card-v2 card-type-yc">
            <h3>Total Application in DS_YC</h3>
            <p>{renderValue(cardData.DS_YC)}</p>
          </div>
          <div className="card-v2 card-type-total">
            <h3>Total Applications in DS</h3>
            <p>{renderValue(cardData.Total_DS)}</p>
          </div>
        </div>

        {/* BR Section */}
        <div className="cards-column">
          <div className="card-v2 card-type-di">
            <h3>
              Total Application in BR_DI
              <span
                className="info-icon"
                title="Total Applications = DI + MSME applications"
              >
                i
              </span>
            </h3>
            <p>{renderValue(cardData.BR_DI)}</p>
          </div>
          <div className="card-v2 card-type-dfl">
            <h3>Total Application in BR_DFL</h3>
            <p>{renderValue(cardData.BR_DFL)}</p>
          </div>
          <div className="card-v2 card-type-yc">
            <h3>Total Application in BR_YC</h3>
            <p>{renderValue(cardData.BR_YC)}</p>
          </div>
          <div className="card-v2 card-type-total">
            <h3>Total Applications in BR</h3>
            <p>{renderValue(cardData.Total_BR)}</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Cards;

